import type { Theme } from '@mui/material';

import { getBarColor } from 'src/components/dashboard/DashboardPage/widgets/StackedBarWidget/index.styles';

export const styles = {
  StackedBarLegend: (theme: Theme) => ({
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  }),

  listItem: (index: number) => (theme: Theme) => ({
    paddingLeft: 2,
    backgroundColor: getBarColor(theme, index),

    '&:before': {
      content: '"\u2022"', // Unicode Character: “•”
      display: 'inline-block',
      fontSize: 40,
      marginLeft: theme.spacing(-2),
      position: 'absolute',
    },
  }),
};
